import { useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import { updateSessionDetail, loadSessionDetails, trackSessionQuizStart } from './bentoApiModule';
export default function useSessionActions() {
  var dispatch = useDispatch();
  return useMemo(function () {
    return bindActionCreators({
      updateSessionDetail: updateSessionDetail,
      loadSessionDetails: loadSessionDetails,
      trackSessionQuizStart: trackSessionQuizStart
    }, dispatch);
  }, [dispatch]);
}